import axios from 'axios' // 引入axios
import qs from "qs";
// 将 aioxs 封装为 vue https://api.cessjsge.org的插件https://api.tsctwfdz.com
// 将 aioxs 封装为 vue https://api.cessjsge.org的插件https://api.tsctwfdz.com
const service = axios.create({
    // baseURL: window.APP_CONFIG?.API_BASE_URL || 'http://127.0.0.1:10070',
    baseURL: (window.APP_CONFIG && window.APP_CONFIG.API_BASE_URL) || 'http://127.0.0.1:10070',
    withCredentials: false,
})
/*service.defaults.headers.post['Accept'] = 'application/json';*/
service.defaults.headers.post['Content-Type'] = 'application/json';
// 在 axios 的拦截器中添加一段内容：
service.interceptors.request.use(function(config) {
	//在这里可以添加请求头
	var lang = localStorage.getItem('lang') || 'en'
	config.headers['languageCode'] = lang;
	config.headers['token'] = localStorage.getItem('token');

		return config
}, function(error) {
	return Promise.reject(error)
})
//拦截响应，做统一处理
service.interceptors.response.use(
	response => {
		return response
	}, //接口错误状态处理，也就是说无响应时的处理
	error => {
		return Promise.reject(error) // 返回接口返回的错误信息
	})

async function request(options) {
	// 这里主要是post方法的封装，get方法同理
	var lang = localStorage.getItem('lang') || 'en'
	//options.method = 'post'
	if (options.config === 'formData') {
		options.headers = {
			'Content-Type': 'multipart/form-data'
		}
	} else if (options.config === 'json'  || !options.config) {
		options.headers = {
			'Content-Type': 'application/json'
		}
	} else {
		options.data = qs.stringify(options.data, {
			arrayFormat: "repeat"
		});

	}
	if(options.method == 'get'){
		// 构建查询参数
		let params = '';
		if(options.data){
			// 如果是对象，转换为查询字符串
			if(typeof options.data === 'object'){
				params = qs.stringify(options.data, { arrayFormat: "repeat" });
			} else {
				params = options.data;
			}
		}

		// 添加语言参数
		let langParam = 'languageCode=' + lang;
		if(params){
			options.url = options.url + '?' + langParam + '&' + params;
		} else {
			options.url = options.url + '?' + langParam;
		}
	}
	return new Promise((resolve, reject) => {
		service(options).then(response => {
			//  这里主要根据后来返回的数据作判断，请根据实际情况
			if (response.data.code === 200) {
				let res = response.data;
				resolve(res)
				// console.log("拦截器",res)
			} else {
				let res = response.data;
				resolve(res)
				if(response.data.code == 300 || response.data.code == 401){
					localStorage.removeItem('token');
					window.location.href =  window.location.protocol + '//' +window.location.host+'/login';
				}

				// reject(response.data)
			}
		}).catch(error => {
			reject(error)
			// 显示拦截器对respone处理后的可读错误
		})
	})
}

export default request
